import React, { Component } from "react";
import formBuilderHelper from "../../helperFunctions/formBuilderHelper/formBuilderHelper";
import FileSaver from "file-saver";
import moment from "moment";
import axiosInstance from "../../api/utils/axiosInstance";
import submitFormsApi from "../../api/formsApi/submitFormsApi";
import submitUploadedFiles from "../../api/formsApi/submitUploadedFiles";
import { connect } from "react-redux";
import {
  formSubmitError,
  formSubmitSuccess,
} from "../../store/actions/forms/formActions";
import { withRouter } from "react-router";
import { toast } from "react-toastify";
import { message } from "antd";

class DynamicFormBuilder extends Component {
  state = {
    isLoading: false,
  };
  userInputHandler = (e, isOib, secondaryOib) => {
    let newState = { ...this.props.parentState.initialFormData };
    let value = e.target.value;
    let id = e.target.id;
    let userInputObj = {
      initialFormData: {
        ...this.props.parentState.initialFormData,
        groupList: [
          ...newState.groupList.map((element) => {
            return {
              ...element,
              controlList: [
                ...element.controlList.map((el) => {
                  return el.uuid === id
                    ? {
                      ...el,
                      value,
                    }
                    : el;
                }),
              ],
            };
          }),
        ],
      },
    };
    this.props.setUserInputState(userInputObj, isOib, value, secondaryOib);
  };

  userInputHandlerNumber = (e, isOib, secondaryOib) => {
    let newState = { ...this.props.parentState.initialFormData };
    let value = e.target.value.replace(/\D/, "");
    let id = e.target.id;
    let userInputObj = {
      initialFormData: {
        ...this.props.parentState.initialFormData,
        groupList: [
          ...newState.groupList.map((element) => {
            return {
              ...element,
              controlList: [
                ...element.controlList.map((el) => {
                  return el.uuid === id
                    ? {
                      ...el,
                      value,
                    }
                    : el;
                }),
              ],
            };
          }),
        ],
      },
    };
    this.props.setUserInputState(userInputObj, isOib, value, secondaryOib);
  };

  handleDayClick = (date, dateString, id) => {
    const newState = { ...this.props.parentState.initialFormData };

    const setParentState = {
      ...this.props.parentState,
      initialFormData: {
        ...this.props.parentState.initialFormData,
        groupList: [
          ...newState.groupList.map((element) => {
            return {
              ...element,
              controlList: [
                ...element.controlList.map((el) => {
                  return id === el.controlIndex
                    ? {
                      ...el,
                      value: dateString,
                    }
                    : el;
                }),
              ],
            };
          }),
        ],
      },
    };
    this.props.setSelectedDate(setParentState);
  };

  clearFormHandler = (e) => {
    let setParentState = { ...this.props.parentState };
    setParentState.initialFormData.groupList.map((element) => {
      element.controlList.map((el) => {
        el.value = "";
      });
    });
    setParentState.selectedFiles = [];
    setParentState.invalidOib = false;
    setParentState.error = false;
    setParentState.uploadError = false;
    setParentState.clearUploadedFile = false;
    this.props.clearForm(setParentState);
  };

  uploadHandler = (file, id) => {
    // provjera veličine datoteke, konverzija iz byte-ova u megabajte
    const isFileLt10MB = file.file.size / 1024 / 1024 < 10;

    if (file.file.size && !isFileLt10MB) {
      message.error("Nije dopušteno učitavanje datoteka većih od 10MB.");
      this.props.removeSelectedFile(id);
      return;
    }

    if (file.file.status === "removed") {
      this.props.removeSelectedFile(id);
      return;
    }

    let newFiles = {
      id: id,
      file: null,
      name: file.file.name,
      uid: file.file.uid,
    };
    newFiles.file = file.file;
    this.props.setSelectedFiles(newFiles);
  };

  submitFormHandler = async (e) => {
    e.preventDefault();
    let newState = { ...this.props.parentState.initialFormData };
    this.setState({ isLoading: true })
    let error = newState.groupList
      .map((el) => {
        return el.controlList.filter((element) => {
          return (
            element.isVisible &&
            element.required &&
            (element.controlType === "text" ||
              element.controlType === "oib" ||
              element.controlType === "mail" ||
              element.controlType === "date" ||
              element.controlType === "number" ||
              element.controlType === "dropdown")
          );
        });
      })
      .flat()
      .every((element) => element.value.length > 0);

    if (this.props.parentState.invalidOib === true) {
      this.setState({ isLoading: false })
      this.props.formSubmitError(
        true,
        "OIB je neispravan! Molimo unesite ispravan OIB!"
      );
      return;
    }

    if (
      this.props.parentState.secondaryOib.value &&
      this.props.parentState.secondaryOib.value.length > 0 &&
      this.props.parentState.secondaryOib.invalidOib
    ) {
      this.setState({ isLoading: false })
      this.props.formSubmitError(
        true,
        "OIB je neispravan! Molimo unesite ispravan OIB! "
      );
      return;
    }
    
    if(!error){
      this.setState({ isLoading: false })
    }
    this.props.submitForm(!error);

    if (
      this.props.parentState.update &&
      error &&
      !this.props.parentState.invalidOib
    ) {
      const { selectedFiles, attachments, attachmentsForDelete } =
        this.props.parentState;
      let newFilesForUpload = [];
      const { zahtjevAtrId } = this.props.parentState.initialFormData;

      try {
        const res = await axiosInstance.patch(
          `/requests/edit/${zahtjevAtrId}`,
          this.props.parentState.initialFormData
        );

        if (attachmentsForDelete.length > 0) {
          attachmentsForDelete.map(
            async (element) =>
              await axiosInstance.delete(
                `delete/attachment/${element.zahtjeviDokumentiId}`
              )
          );
        }

        if (selectedFiles.length > 0) {
          //indexi selektiranih fajlova
          const selectedFilesId = selectedFiles.map((element) => element.id);
          const attachmentIds = attachments.map((element) =>
            element.controlIndex.toString()
          );

          newFilesForUpload = selectedFiles.filter(
            (element) => !attachmentIds.includes(element.id)
          );

          if (newFilesForUpload.length > 0) {
            try {
              const uploadNewFiles = newFilesForUpload.map(async (element) => {
                const formData = new FormData();
                formData.append("file", element.file);
                formData.append("zahtjevId", res.data.zahtjevId);
                formData.append("zahtjevAtrId", res.data.zahtjevAtrId);
                formData.append("controlIndex", element.id);
                formData.append("vrstaDokumentaId", 1);

                const response = await axiosInstance.post(
                  "/upload/attachment",
                  formData
                );
              });
            } catch (e) {
              this.props.formSubmitError(
                true,
                e.response.data.message || "Nešto je pošlo po krivu!"
              );
            }
          }
        }
        this.props.formSubmitSuccess(false, "Zahtjev je uspješno spremljen!");
        this.props.hideModal();
        this.props.openPotpisivanjeModal(res.data.zahtjevAtrId);
        this.props.getSearchData();
        return;
      } catch (error) {
        this.props.formSubmitError(false, error.response.data.message);
      } finally {
        this.setState({ isLoading: false })
      }
      // this.props.history.push("/");
    }

    //unos zahtjeva

    if (
      error &&
      !this.props.parentState.invalidOib &&
      !this.props.parentState.update
    ) {
      try {
        const res = await submitFormsApi(
          "/upload/",
          this.props.parentState.initialFormData
        );

        const selectedFiles = this.props.parentState.selectedFiles.sort(
          (a, b) => a.id - b.id
        );

        selectedFiles.length > 0 &&
          selectedFiles.map(async (element) => {
            const formData = new FormData();
            formData.append("file", element.file);
            formData.append("zahtjevId", res.data.zahtjevId);
            formData.append("zahtjevAtrId", res.data.zahtjevAtrId);
            formData.append("controlIndex", element.id);
            formData.append("vrstaDokumentaId", 1);
            try {
              const response = await axiosInstance.post(
                "/upload/attachment",
                formData
              );
            } catch (e) {
              this.props.formSubmitError(
                false,
                "Nešto je pošlo po krivu, pokušajte ponovo!"
              );
            }
          });

        this.props.history.push("/");
        this.props.formSubmitSuccess(false, "Obrazac je uspješno pohranjen!");
        // this.props.showPotpisivanjeModal();
      } catch (e) {
        this.props.formSubmitError(
          true,
          e.response.data.message ||
          "Nešto je pošlo po krivu, pokušajte ponovo!"
        );
      } finally {
        this.setState({ isLoading: false })
      }
    }
  };

  downloadAttachments = (e, index, type, fileName) => {
    e.preventDefault();
    if (this.props.parentState.attachments[index]) {
      let binaryString = window.atob(
        this.props.parentState.attachments[index].fileContents
      );
      let binaryLen = binaryString.length;
      let bytes = new Uint8Array(binaryLen);
      for (let i = 0; i < binaryLen; i++) {
        let ascii = binaryString.charCodeAt(i);
        bytes[i] = ascii;
      }

      let blob = new Blob([bytes], {
        type,
      });
      if (window.navigator && window.navigator.msSaveOrOpenBlob) {
        window.navigator.msSaveOrOpenBlob(blob, fileName);
      } else {
        FileSaver.saveAs(blob, fileName);
      }
    }
  };

  render() {
    const data = formBuilderHelper(
      this.props.parentState,
      this.userInputHandler,
      this.uploadHandler,
      this.clearFormHandler,
      this.props.hideModal,
      this.downloadAttachments,
      this.handleDayClick,
      this.props.dropdownHandler,
      this.props.autocompleteCountryHandler,
      this.props.autocompleteCityHandler,
      this.props.autocompleteDistrictHandler,
      this.userInputHandlerNumber,
      this.props.removeAttachment,
      this.props.openConfirmationModal,
      this.props.checkboxHandler,
      this.state.isLoading,
    );

    return (
      <div className="row justify-content-center" key={"form"}>
        <div className="col-lg-5 col-md-6  align-self-center">
          <div
            className="card p-4"
            style={{
              border: "none",
              boxShadow: "0px 20px 20px 0px rgba(0,0,0,.1)",
            }}
          >
            <div
              className="card-title "
              key={"label"}
              style={{ fontWeight: "bold", textAlign: "center" }}
            >
              {this.props.parentState.formLabel}
            </div>
            <form
              noValidate
              onSubmit={
                this.props.parentState.readOnly
                  ? this.props.openClassModal
                  : this.submitFormHandler
              }
              key="Form"
              className="main-form"
            >
              {data}
            </form>
          </div>
        </div>
      </div>
    );
  }
  //
}

const mapDispatchToProps = (dispatch) => {
  return {
    formSubmitError: (error, notificationMessage) =>
      dispatch(formSubmitError(error, notificationMessage)),
    formSubmitSuccess: (error, notificationMessage) =>
      dispatch(formSubmitSuccess(error, notificationMessage)),
  };
};

export default withRouter(
  connect(null, mapDispatchToProps)(DynamicFormBuilder)
);
